<template>
  <v-app>
    <v-container class="pa-0">
      <v-row
        class="banner"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-responsive :aspect-ratio="1065/531">
            <template v-if="user.login_enable">
              <navigation
                :class="{ 'is-mini': miniNavigation }"
                v-on:select-user="showUserPanel = !showUserPanel"
                :logo="brand.logo"
                  ></navigation>
            </template>
            <v-img :src="store.image"/>
          </v-responsive>
        </v-col>
      </v-row>
      <v-row
        class="mt-n5"
        no-gutters
        justify="center"
      >
        <user-panel
          v-if="showUserPanel"
          v-body-scroll-lock="showUserPanel"
          v-on:close="showUserPanel = false"
        ></user-panel>
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-card
            rounded="xl"
            elevation="8"
            min-height="100vh"
          >
            <v-card-title
              class="font-weight-bold"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="3"
                  >
                    <v-avatar size="100%">
                      <v-img :src="brand.logo"/>
                    </v-avatar>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>{{ brand.name }}</div>
                    <div>{{ store.name }}</div>
                    <div
                      class="my-2 text-caption text--secondary"
                    >{{ store.tel }}・{{ store.address }}</div>
                    <div>
                      <v-btn
                        depressed
                        rounded
                        :to="{ name: 'Brand' }"
                        class="mr-2 my-2"
                        exact
                      >
                        <v-icon left>mdi-store</v-icon>
                        其他分店
                      </v-btn>
                      <v-btn
                        depressed
                        rounded
                        :href="`tel:${store.tel}`"
                        class="mr-2 my-2"
                      >
                        <v-icon left>mdi-phone</v-icon>
                        撥打電話
                      </v-btn>
                      <v-btn
                        depressed
                        rounded
                        :href="`https://maps.google.com/?q=${store.address}`"
                        target="_blank"
                        class="mr-2 my-2"
                      >
                        <v-icon left>mdi-map-marker</v-icon>
                        地圖
                      </v-btn>
                    </div>
                    <div
                      class="mt-4 text-body-2 grey--text text--darken-1"
                      v-if="store.welcome"
                    >
                      <vue-markdown :source="store.welcome" :options="{ linkify: true }"/>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>

            <div
              class="pa-4"
            >
              <div
                class="font-weight-bold mb-4"
              >
                預約服務項目
              </div>
              <v-container
                class="px-0 rounded-xl"
              >
                <v-row>
                  <v-col
                    cols="6"
                    v-for="service in services"
                    v-bind:key="service.token"
                    v-on:click="onClickService(service)"
                  >
                    <v-sheet>
                      <v-img
                        class="rounded-lg mb-2"
                        :src="service.image"
                      />
                      <div>
                        <div class="font-weight-bold">
                          {{ service.name }}
                        </div>
                        <div class="d-flex align-center text--secondary">
                          <v-icon
                            class="mr-1"
                            small
                          >mdi-timer-outline</v-icon>
                          {{ service.duration }} 分鐘
                        </div>
                      </div>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <div class="my-4 text-center text-caption text--secondary">
            bookNow.tw ©️ All Rights Reserved.<br>
            <span v-if="brand.name">{{ brand.name }}</span>
            <span v-else>品牌</span>
            保留接受或拒絕預訂之權力
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="serviceDialog"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
      ref="dialog"
    >
      <v-card
        rounded="0"
      >
        <v-toolbar
          dark
          color="pink"
          elevation="0"
          class="flex-grow-0"
        >
          <v-btn
            icon
            dark
            v-on:click="clearService"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="font-weight-bold">{{ service.name }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="px-0">
          <v-container class="pa-0">
            <v-row
              no-gutters
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="5"
              >
                <v-stepper
                  v-model="serviceStep"
                  class="elevation-0"
                >
                  <v-stepper-items>
                    <v-stepper-content
                      step="1"
                      class="pa-0"
                    >
                      <v-img
                        class="rounded-0"
                        :src="service.image"
                      />
                      <div class="pa-4">
                        <div class="mb-4">
                          <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                            {{ service.name }}
                          </div>
                          <div class="d-flex align-center text--secondary">
                            <v-icon
                              class="mr-1"
                              small
                            >mdi-timer-outline</v-icon>
                            {{ service.duration }} 分鐘
                          </div>
                        </div>
                        <vue-markdown class="markdown-textview" :source="service.desc" :options="{ linkify: true }"/>
                        <vue-markdown class="markdown-textview" :source="service.comment" :options="{ linkify: true }"/>

                        <v-form
                          v-if="service.fields"
                          v-model="serviceFieldsValid"
                        >
                          <v-container class="px-0">
                            <v-row
                              dense
                              v-for="field in service.fields"
                              v-bind:key="field.token"
                            >
                              <v-col
                                v-if="field.type === 'CHECKBOX'"
                              >
                                <v-checkbox
                                  color="pink"
                                  v-model="serviceOptions.fields[field.token]"
                                  :value="field.field"
                                  :label="field.field"
                                  :rules="field.required ? requiredRules : null"
                                  dense
                                  hide-details="auto"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </div>
                    </v-stepper-content>

                    <v-stepper-content
                      step="2"
                      class="pa-0"
                    >
                      <div
                        class="pa-6 pink lighten-5 rounded-b-xl"
                      >
                        <template v-if="service.staff && service.staff.length > 0">
                          <div
                            class="text-caption pink--text font-weight-bold"
                          >選擇服務人員</div>
                          <v-container
                            class="px-0 mb-4"
                            v-if="selectedStaff"
                          >
                            <v-row class="d-block text-no-wrap overflow-x-auto">
                              <v-col
                                cols="3"
                                class="staff-item d-inline-block"
                                v-for="staff in service.staff"
                                v-bind:key="staff.token"
                                v-on:click="onClickStaff(staff.token)"
                              >
                                <v-img
                                  :src="staff.image"
                                  aspect-ratio="1"
                                  class="staff-avatar white rounded-circle mb-2"
                                  :class="{ 'is-selected': staff.token === selectedStaff }"
                                  v-if="staff.image"
                                />
                                <v-responsive
                                  class="staff-avatar pink lighten-2 rounded-circle"
                                  :class="{ 'is-selected': staff.token === selectedStaff }"
                                  :aspect-ratio="1"
                                  v-else
                                >
                                  <v-avatar
                                    color="pink"
                                    size="100%"
                                  >
                                    <span class="text-center white--text text-h5 text-truncate">{{ staff.name.charAt(0) }}</span>
                                  </v-avatar>
                                </v-responsive>
                                <div
                                  class="mt-1 grey--text font-weight-bold text-center text-truncate"
                                  :class="{ 'text--darken-4': staff.token === selectedStaff }"
                                >
                                  {{ staff.name }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container
                            class="px-0 mb-4"
                            v-else
                          >
                            <v-row>
                              <v-col
                                cols="4"
                                v-for="staff in service.staff"
                                v-bind:key="staff.token"
                                v-on:click="onClickStaff(staff.token)"
                              >
                                <v-img
                                  :src="staff.image"
                                  aspect-ratio="1"
                                  class="white rounded-lg"
                                  v-if="staff.image"
                                />
                                <v-responsive
                                  class="pink rounded-lg"
                                  :aspect-ratio="1"
                                  v-else
                                >
                                  <v-avatar
                                    class="staff-avatar"
                                    color="pink"
                                    size="100%"
                                  >
                                    <span class="white--text text-h5">{{ staff.name.charAt(0) }}</span>
                                  </v-avatar>
                                </v-responsive>
                                <div class="mt-1 grey--text text--darken-4 font-weight-bold">
                                  {{ staff.name }}
                                </div>
                                <div
                                  class="align-center text--secondary"
                                  v-if="staff.desc"
                                >
                                  {{ staff.desc }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>
                        <div
                          class="text-caption pink--text font-weight-bold"
                        >選擇日期與人數</div>
                        <div
                          class="text-caption text--secondary"
                        >若日期反灰無法選擇，代表當日預約已滿或當日未開放預約</div>
                        <v-container class="px-0">
                          <v-row>
                            <v-col>
                              <v-menu
                                v-model="datePickerMenu"
                                :close-on-content-click="false"
                                min-width="auto"
                                rounded="lg"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    :items="serviceOptions.date"
                                    prepend-icon="mdi-calendar"
                                    :value="formatedSelectedDate"
                                    label="日期"
                                    v-bind="attrs"
                                    v-on="on"
                                    color="pink"
                                    readonly
                                    hide-details
                                  />
                                </template>
                                <v-date-picker
                                  v-model="selectedDate"
                                  :min="serviceOptions.minDate"
                                  :max="serviceOptions.maxDate"
                                  :allowed-dates="allowDates"
                                  color="pink"
                                  no-title
                                  v-on:input="datePickerMenu = false"
                                  :day-format="dayFormatter"
                                />
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-select
                                :items="serviceOptions.amount"
                                item-color="pink"
                                v-model="selectedAmount"
                                prepend-icon="mdi-account"
                                label="人數"
                                color="pink"
                                hide-details
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>

                        <v-slide-y-transition>
                          <div v-if="selectedDate && selectedAmount">
                            <div
                              class="mt-4 text-caption pink--text font-weight-bold"
                            >選擇預約時間</div>
                            <v-container class="px-0">
                              <v-row>
                                <v-col>
                                  <template
                                    v-if="isServiceTimeLoading"
                                  >
                                    <v-skeleton-loader type="chip"/>
                                  </template>
                                  <template v-else>
                                    <template
                                      v-if="serviceOptions.time.length === 0"
                                    >
                                      <div
                                        class="mt-4 text-center text-caption font-weight-bold"
                                      >無可預約的時間，請選擇其他日期、人數！</div>
                                    </template>
                                    <template v-else>
                                      <v-chip-group
                                        v-model="selectedTime"
                                        active-class="font-weight-bold pink white--text"
                                        column
                                      >
                                        <v-chip
                                          class="white"
                                          v-for="slot in serviceOptions.time"
                                          v-bind:key="slot"
                                          :value="slot"
                                          filter
                                        >
                                          {{ slot }}
                                        </v-chip>
                                      </v-chip-group>
                                    </template>
                                  </template>
                                </v-col>
                              </v-row>
                            </v-container>
                          </div>
                        </v-slide-y-transition>
                      </div>

                      <v-slide-y-transition>
                        <div
                          class="mt-4 pa-4"
                          v-if="selectedDate && selectedAmount && selectedTime"
                        >
                          <div
                            class="text-center mb-4"
                          >
                            <div
                              class="text-caption pink--text font-weight-bold"
                            >填寫預約資料</div>
                            <div class="mb-2 text-h6 font-weight-bold">{{ brand.name }} - {{ store.name }}</div>
                            <div>{{ service.name }}</div>
                            <div>{{ selectedDate | moment('M/D (ddd)') }} {{ selectedTime }}・{{ selectedAmount }} 位</div>
                          </div>
                          <v-form
                            v-model="valid"
                          >
                            <v-container class="px-0">
                              <v-row>
                                <v-col>
                                  <v-text-field
                                    filled
                                    rounded
                                    dense
                                    label="姓名*"
                                    color="pink"
                                    prepend-icon="mdi-account"
                                    v-model.trim="name"
                                    :rules="nameRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col>
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    label="性別*"
                                    :items="[{ text: '男', value: 'male' }, { text: '女', value: 'female' }]"
                                    item-color="pink"
                                    prepend-icon="mdi-human-male-female"
                                    color="pink"
                                    v-model.trim="gender"
                                    :rules="genderRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-text-field
                                    type="tel"
                                    filled
                                    rounded
                                    dense
                                    label="手機號碼*"
                                    color="pink"
                                    prepend-icon="mdi-phone"
                                    v-model.trim="cell"
                                    :rules="cellRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-text-field
                                    type="email"
                                    filled
                                    rounded
                                    dense
                                    label="Email"
                                    color="pink"
                                    prepend-icon="mdi-email"
                                    v-model.trim="email"
                                    :rules="emailRules"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense
                                v-if="serviceOptions.purposes.length > 0"
                              >
                                <v-col>
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    label="預約目的"
                                    :items="serviceOptions.purposes"
                                    item-color="pink"
                                    prepend-icon="mdi-format-list-bulleted-type"
                                    color="pink"
                                    v-model="purpose"
                                    multiple
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-for="field in service.fields"
                                v-bind:key="field.token"
                                dense
                              >
                                <v-col v-if="field.type === 'TEXT'">
                                  <v-text-field
                                    filled
                                    rounded
                                    dense
                                    prepend-icon="mdi-playlist-edit"
                                    color="pink"
                                    :label="field.required ? `${field.field}*` : field.field"
                                    :hint="field.placeholder || null"
                                    :rules="validePattern(field.required, field.pattern)"
                                    v-model.trim="serviceOptions.fields[field.token]"
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col v-else-if="field.type === 'SELECT'">
                                  <v-select
                                    filled
                                    rounded
                                    dense
                                    prepend-icon="mdi-text-box"
                                    item-color="pink"
                                    color="pink"
                                    :items="field.options"
                                    :label="field.required ? `${field.field}*` : field.field"
                                    :rules="validePattern(field.required, field.pattern)"
                                    v-model.trim="serviceOptions.fields[field.token]"
                                    :multiple="field.multiple"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <v-textarea
                                    filled
                                    rounded
                                    dense
                                    label="備註"
                                    prepend-icon="mdi-comment"
                                    color="pink"
                                    v-model.trim="comment"
                                    multiple
                                    rows="2"
                                    hide-details="auto"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </div>
                      </v-slide-y-transition>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container class="px-0">
            <v-row
              no-gutters
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="5"
              >
                <template
                  v-if="serviceStep === 1"
                >
                  <v-container class="pa-0">
                    <v-row
                      dense
                    >
                      <v-col>
                        <v-btn
                          depressed
                          block
                          rounded
                          color="pink"
                          v-on:click="serviceStep = 2"
                          :disabled="service.fields && !serviceFieldsValid"
                          class="white--text"
                        >
                          bookNow!
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>

                <template
                  v-if="serviceStep === 2"
                >
                  <v-container class="pa-0">
                    <v-row
                      dense
                    >
                      <v-col
                        cols="auto"
                      >
                        <v-btn
                          depressed
                          rounded
                          block
                          color="pink"
                          v-on:click="resetServiceStep"
                          class="white--text"
                        >
                          上一步
                        </v-btn>
                      </v-col>
                      <v-col>
                        <v-btn
                          depressed
                          rounded
                          block
                          color="pink"
                          v-on:click="submitBook"
                          class="white--text"
                          :disabled="isSubmitDisabled"
                          :loading="isSubmitting"
                        >
                          送出
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue';
import Axios from '@/helpers/axios';
import VueMarkdown from 'vue-markdown-render';
import PhoneNumber from 'awesome-phonenumber';
import navigation from '@/components/Navigation.vue';
import userPanel from '@/components/UserPanel.vue';
import VBodyScrollLock from 'v-body-scroll-lock';
import { mapState } from 'vuex';

Vue.use(VBodyScrollLock);

export default {
  name: 'Store',
  components: {
    VueMarkdown,
    navigation,
    userPanel,
  },
  beforeMount() {
    const data = {
      brandId: this.$route.params.brandId,
      storeId: this.$route.params.storeId,
    };

    Axios({
      method: 'POST',
      url: 'store',
      data,
    })
      .then((api) => {
        if (api.status === 200) {
          this.brand = api.data.brand;
          this.store = api.data.store;
          this.services = api.data.services;
        }
      });
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      miniNavigation: false,
      showNavigation: 'none',
      showUserPanel: false,
      serviceStep: 1,
      serviceDialog: false,
      datePickerMenu: false,
      nameRules: [
        (input) => !!input.trim() || '必填項目',
      ],
      cellRules: [
        (input) => !!input.trim() || '必填項目',
        () => {
          if (this.cellInstance.isValid()) return true;
          return '不正確的電話格式';
        },
      ],
      genderRules: [
        (input) => !!input || '必填項目',
      ],
      emailRules: [
        (input) => input === '' || /.+@.+\..+/.test(input.trim()) || '格式不正確',
      ],
      requiredRules: [
        (input) => !!input || '必填項目',
      ],
      isSubmitting: false,

      brand: {
        name: '',
        logo: '',
        image: '',
      },

      store: {
        token: '',
        name: '',
        image: '',
        address: '',
        tel: '',
        welcome: '',
      },

      services: [],

      service: {
        comment: '',
        desc: '',
        duration: 0,
        image: '',
        name: '',
        token: '',
        fields: [],
      },
      isServiceTimeLoading: false,
      serviceFieldsValid: false,

      serviceOptions: {
        minDate: '',
        maxDate: '',
        disableDate: [],
        amount: [],
        time: [],
        purposes: [],
      },

      selectedStaff: null,
      selectedDate: null,
      selectedAmount: null,
      selectedTime: null,
      name: '',
      cell: '',
      gender: '',
      email: '',
      purpose: '',
      comment: '',
      valid: false,
    };
  },
  created() {
    // this.name = this.user.name;
    // this.cell = this.user.cell;
    // this.email = this.user.email;
    // this.gender = this.user.sex;
  },
  computed: {
    ...mapState([
      'user',
    ]),
    formatedSelectedDate() {
      if (this.selectedDate === null) return null;
      return this.$moment(this.selectedDate).format('M/D (ddd)');
    },
    cellInstance() {
      return new PhoneNumber(this.cell, 'TW');
    },
    isSubmitDisabled() {
      return !(this.selectedDate && this.selectedAmount && this.selectedTime && this.valid);
    },
  },
  methods: {
    onClickService(service) {
      this.service = service;
      if ('fields' in this.service) {
        this.$set(this.serviceOptions, 'fields', {});
        this.service.fields.forEach((field) => {
          this.$set(this.serviceOptions.fields, field.token, null);
        });
      }
      if (this.service.staff && this.service.staff.length === 1) this.selectedStaff = this.service.staff[0].token;
      this.serviceDialog = true;
    },
    clearService() {
      this.serviceStep = 1;
      this.resetForm();
      this.serviceDialog = false;
      this.service = {
        comment: '',
        desc: '',
        duration: 0,
        image: '',
        name: '',
        token: '',
      };
    },
    initServiceDetail() {
      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
      };

      Axios({
        method: 'POST',
        url: 'schedule',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.serviceOptions.amount = [];
            this.serviceOptions.minDate = api.data.startDate;
            this.serviceOptions.maxDate = api.data.endDate;
            this.serviceOptions.disableDate = api.data.disableDate;

            Array.from(Array(api.data.maxAmount).keys()).forEach((item, index) => {
              this.serviceOptions.amount.push({
                text: `${index + 1} 位`,
                value: index + 1,
              });
            });

            if ('amount' in api.data) this.selectedAmount = api.data.amount;
            if ('purposes' in api.data) this.serviceOptions.purposes = api.data.purposes;
          }
        });
    },
    onClickStaff(token) {
      this.selectedStaff = token;
    },
    allowDates(date) {
      if (this.serviceOptions.disableDate.includes(date)) return false;
      return true;
    },
    getServiceTime() {
      this.serviceOptions.time = [];

      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
        date: this.selectedDate,
        amount: this.selectedAmount,
      };

      if (this.selectedStaff) data.staffId = this.selectedStaff;

      this.isServiceTimeLoading = true;

      Axios({
        method: 'POST',
        url: 'schedule',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.serviceOptions.time = api.data.availableTime;
          }

          this.isServiceTimeLoading = false;
        })
        .catch(() => {
          this.isServiceTimeLoading = false;
        });
    },
    dayFormatter(date) {
      return parseInt(date.slice(-2), 10);
    },
    resetServiceStep() {
      this.serviceStep = 1;
      this.resetForm();
    },
    resetForm() {
      this.selectedStaff = null;
      this.selectedDate = null;
      this.selectedAmount = null;
      this.selectedTime = null;
      this.name = '';
      this.cell = '';
      this.gender = '';
      this.email = '';
      this.purpose = '';
      this.comment = '';
      this.valid = true;
    },
    validePattern(required, pattern) {
      const rules = [];

      if (required) rules.push((input) => !!input || '必填項目');

      if (pattern) rules.push((input) => new RegExp(pattern).test(input));

      return rules;
    },
    submitBook() {
      const data = {
        brandId: this.$route.params.brandId,
        storeId: this.$route.params.storeId,
        serviceId: this.service.token,
        date: this.selectedDate,
        amount: this.selectedAmount,
        time: this.selectedTime,
        name: this.name,
        contact: this.cellInstance.getNumber(),
        gender: this.gender,
        email: this.email,
        comment: this.comment,
      };

      if (this.serviceOptions.purposes.length > 0) data.purpose = this.purpose;

      if ('fields' in this.serviceOptions) data.fields = this.serviceOptions.fields;

      if (this.selectedStaff) data.staffId = this.selectedStaff;

      this.isSubmitting = true;

      Axios({
        method: 'POST',
        url: 'create',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            this.$router.push({ name: 'Booked', params: { bookId: api.data.token } });
            this.isSubmitting = false;
          }
        })
        .catch(() => {
          this.isSubmitting = false;
        });
    },
  },
  watch: {
    serviceStep(newValue, oldValue) {
      if (newValue === 2 && oldValue === 1) {
        this.initServiceDetail();
      }
    },
    selectedStaff() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
    selectedDate() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
    selectedAmount() {
      this.selectedTime = null;
      if (this.selectedDate && this.selectedAmount) this.getServiceTime();
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: sticky
  top: 0

.staff-item
  max-width: 22%
  width: 22%
  min-width: 75px

  cursor: pointer

.staff-avatar
  &.is-selected
    box-shadow: 0 0 0 2px #fce4ec, 0 0 0 4px #e91e63
</style>
